"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryCouponComboSearch = queryCouponComboSearch;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var requestUrl = '/xyCouponCombo';
function queryCouponComboSearch(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/search',
    method: 'get',
    params: query
  });
}